(ns manage.ad-variant.creation.link.ps-project-item
  (:require ["@mui/material/Box$default" :as Box]
            ["@mui/material/Checkbox$default" :as Checkbox]
            ["@mui/material/Stack$default" :as Stack]
            ["@mui/material/Typography$default" :as Typography]
            [uix.core :refer [$ defui]]))

(defui ps-project-item
  [{:keys [logo name disabled value selected-values on-click]}]
  (let [selected (some? ((or selected-values #{}) value))
        background-color "white"]
    ($ Box {:width "48%"
            :on-click #(when (not disabled) (on-click [value (not selected)]))
            :key value
            :sx #js {:opacity (if disabled 0.5 1)
                     :minHeight 140
                     :border 1
                     :borderColor (if selected "grey.20" "grey.60")
                     :backgroundColor background-color
                     :borderRadius 1}}
       ($ Stack {:direction "column"
                 :sx #js {:p 1
                          :gap 1}}
          ($ Stack {:direction "row"
                    :disabled true
                    :alignItems "center"
                    :justify-content "space-between"}
             ($ Typography {:variant "h5"} name)
             ($ Checkbox {:disabled disabled
                          :checked selected
                          :sx #js {:p 0}}))
          (when logo
            ($ :img
               {:src logo
                :width "100%"
                :height "100%"
                :style {:border-radius "4px"}}))))))
